module.exports = "/images/label_new.png?8d90569a955573efc941d0562d90e4b8";